export default __webpack_public_path__ + "static/media/postcardHero.fe98e667.jpg";